import { useState, useEffect } from "react";
import { Autocomplete, TextField, CircularProgress } from "@mui/material";
import { useArticles } from "../UseDataReader/useArticles";

export default function ArticleAutocompleteInsert({
  reloadKey,
  value,
  onChange,
  onSelect,
  onClear,
  label = "Kërko Artikullin",
  labelId,
  priceType,
}) {
  const [inputValue, setInputValue] = useState("");
  const [searchTerm, setSearchTerm] = useState("");

  const { listArticles, loadingInitial, loadingMore, setPage, hasMore } =
    useArticles(searchTerm);

  // =========================
  // DEBOUNCE SEARCH
  // =========================
  useEffect(() => {
    const delay = setTimeout(() => {
      setSearchTerm(inputValue);
      setPage(1);
    }, 300);

    return () => clearTimeout(delay);
  }, [inputValue]);

  // =========================
  // SCROLL PAGINATION
  // =========================
  const handleScroll = (event) => {
    const listbox = event.currentTarget;

    if (
      listbox.scrollTop + listbox.clientHeight >= listbox.scrollHeight - 5 &&
      hasMore &&
      !loadingMore
    ) {
      setPage((prev) => prev + 1);
    }
  };

  // =========================
  // CHANGE HANDLER
  // =========================
  const handleChange = (event, option) => {
    if (!option) {
      setInputValue("");
      onClear?.();
      return;
    }

    setInputValue(`${option.Barcode} - ${option.ArticleName}`);
    onSelect?.(option);
  };

  useEffect(() => {
    if (!value && labelId) {
      setTimeout(() => {
        document.getElementById(labelId)?.focus();
      }, 0);
    }
  }, [value]);
  useEffect(() => {
    if (!value) {
      setInputValue("");
    }
  }, [value]);

  useEffect(() => {
    setSearchTerm("");
    setPage(1);
  }, [reloadKey]);

  return (
    <Autocomplete
      fullWidth
      options={listArticles}
      id={labelId}
      value={value}
      inputValue={inputValue}
      loading={loadingInitial}
      filterOptions={(x) => x}
      onChange={handleChange}
      onInputChange={(e, v, reason) => {
        if (reason === "input") setInputValue(v);
      }}
      onOpen={() => {
        if (value) {
          setSearchTerm("");
          setPage(1);
        }
      }}
      isOptionEqualToValue={(o, v) => o.ArticleID === v?.ArticleID}
      getOptionLabel={(o) => (o ? `${o.Barcode} - ${o.ArticleName}` : "")}
      ListboxProps={{
        style: { maxHeight: 300, overflow: "auto" },
        onScroll: handleScroll,
      }}
      renderOption={(props, option, { index }) => (
        <li
          {...props}
          style={{
            display: "flex",
            justifyContent: "space-between",
            borderBottom: "1px solid #eee",
            padding: "4px 8px",
          }}
        >
          <div>
            <div>{option.Barcode}</div>
            <div style={{ fontSize: 15, fontWeight:"bold"}}>
              {option.ArticleName}
            </div>
          </div>
          
          {priceType === "sales" ? (
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <strong>{(option.SalesPrice ?? 0).toFixed(2)}€</strong>
              {loadingMore && index === listArticles.length - 1 && (
                <CircularProgress size={14} />
              )}
            </div>
          ) : (
            <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
              <strong>{(option.PurchasePrice ?? 0).toFixed(2)}€</strong>
              {loadingMore && index === listArticles.length - 1 && (
                <CircularProgress size={14} />
              )}
            </div>
          )}

          {/* // <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
          //   <strong>{(option.SalesPrice ?? 0).toFixed(2)}€</strong>
          //   {loadingMore && index === listArticles.length - 1 && (
          //     <CircularProgress size={14} />
          //   )}
          // </div> */}
        </li>
      )}
      renderInput={(params) => <TextField {...params} label={label} style={{width:"95%"}}/>}
    />
  );
}
